import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export function AIButton({ kind, context, onResult, label = "Generate with AI", testid, className = "" }) {
  const [loading, setLoading] = useState(false);
  const run = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/ai/generate", { kind, context });
      onResult(data.text);
      toast.success("AI draft ready — review and edit before publishing");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "AI request failed");
    } finally {
      setLoading(false);
    }
  };
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={run}
      disabled={loading}
      className={`inline-flex items-center gap-1.5 text-xs font-semibold text-blue-600 hover:text-blue-700 disabled:opacity-50 transition-colors ${className}`}
    >
      {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5" />}
      {label}
    </button>
  );
}
